// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ApplyV2ReviewApplyProfile{display:flex;flex-direction:column;gap:16px}`, "",{"version":3,"sources":["webpack://./core/components/ApplyDialogV2/ApplyV2ReviewApplyStep/ApplyV2ReviewApplyStepItem/ApplyV2ReviewApplyProfile/ApplyV2ReviewApplyProfile.scss"],"names":[],"mappings":"AAAA,2BACI,YAAA,CACA,qBAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
